import apiClient from './apiClient';

/** 待審核項目 */
export interface PendingItem {
  form_type: string;   // e.g. "SC"
  record_no: string;   // e.g. "P9X01A"
  submitter: string;   // 送審人
  submit_date: string; // 送審時間
  summary: string;     // 摘要（客戶名稱等）
}

/** Approval API client */
export const approvalApi = {
  /** 取得待審核項目清單 */
  async getPending(): Promise<PendingItem[]> {
    const res = await apiClient.get('/api/approvals/pending');
    if (res.data.success) {
      return res.data.data as PendingItem[];
    }
    return [];
  },
};
